export default __webpack_public_path__ + "static/media/blur.91089243.svg";